export const LS_CSRF_TOKEN_KEY = 'utms:csrf_token';
export const LS_THEME_KEY = 'utms:theme';
export const LS_SIDEBAR_COLLAPSED = 'utms:sidebar_collapsed';
export const LS_SELECTED_LANGUAGE = 'utms:selectedLanguage';
export const LS_MODULE_TREE_HINT_SHOWN = 'utms:moduleTreeHintShown';
export const LS_SCHEMES_VIEW_MODE = 'utms:schemesViewMode';
export const LS_COLUMN_SIZING = 'utms:columnSizing';
export const LS_SHOW_ONLY_MY_STANDS_FILTER = 'utms:showOnlyMyStandsEnabled';
export const LS_TESTRESULTS_LOCAL_INFO = 'utms:testresultsLocalInfo';

export const getTableColumnSizingKey = (tableId) => `${LS_COLUMN_SIZING}_${tableId}`;
